__turbopack_context__.v({
  "disclosures": "styles-module-scss-module__3aut8G__disclosures",
});
